import { c as _c } from "react/compiler-runtime";
import { i18n as uiI18n, loadLangBundle as uiLoadLangBundle, LocaleEnum, LocaleProvider as UiLocaleProvider, getLanguageCodeByLocale } from '@systemeio/ui';
import { i18n as fileManagerI18n, loadLangBundle as fileManagerLoadLangBundle, LocaleProvider as FileManagerLocaleProvider, QueryClientProvider } from '@systemeio/file-manager';
import { i18n as tipTapI18n, LocaleProvider as TipTapLocaleProvider, loadLangBundle as tipTapLoadLangBundle } from '@systemeio/tip-tap';
import { HelpBots } from 'help-bots';
import Head from 'next/head';
import Router, { useRouter } from 'next/router';
import React from 'react';
import Header from 'shared/components/header';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useEmailStatusNotification } from 'shared/notifications/hooks/use-email-status-notification';
import { usePaymentNotification } from 'shared/notifications/hooks/use-payment-notification';
import { Snow } from './snow';
import { useChristmas } from './snow/use-christmas';
const disabledPageRoute = '/disabled';
function DashboardLayout(t0) {
  const $ = _c(26);
  const {
    children,
    browserTabTitle
  } = t0;
  useEmailStatusNotification();
  usePaymentNotification();
  const christmasFeatureIsOn = useChristmas();
  const {
    t
  } = useLocoTranslation();
  const {
    pathname
  } = useRouter();
  const {
    isDisabled,
    user
  } = useUser();
  if (isDisabled && pathname !== disabledPageRoute) {
    Router.replace(disabledPageRoute);
  }
  const locale = user?.dashboardLocale ?? LocaleEnum.ENGLISH;
  let t1;
  if ($[0] !== locale) {
    t1 = getLanguageCodeByLocale(locale);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const languageCode = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HelpBots />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== browserTabTitle || $[4] !== t) {
    t3 = t(browserTabTitle);
    $[3] = browserTabTitle;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Head><title>{t3}</title></Head>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Header />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children) {
    t6 = <QueryClientProvider><main className="py-5">{children}</main></QueryClientProvider>;
    $[9] = children;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== languageCode || $[12] !== t6) {
    t7 = <TipTapLocaleProvider i18n={tipTapI18n} languageCode={languageCode} loadLangBundle={tipTapLoadLangBundle}>{t6}</TipTapLocaleProvider>;
    $[11] = languageCode;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== languageCode || $[15] !== t7) {
    t8 = <FileManagerLocaleProvider i18n={fileManagerI18n} languageCode={languageCode} loadLangBundle={fileManagerLoadLangBundle}>{t7}</FileManagerLocaleProvider>;
    $[14] = languageCode;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== languageCode || $[18] !== t8) {
    t9 = <div>{t5}<div className="px-4 sm:px-6 md:px-14"><UiLocaleProvider i18n={uiI18n} languageCode={languageCode} loadLangBundle={uiLoadLangBundle}>{t8}</UiLocaleProvider></div></div>;
    $[17] = languageCode;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== christmasFeatureIsOn) {
    t10 = christmasFeatureIsOn && <Snow />;
    $[20] = christmasFeatureIsOn;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t4 || $[24] !== t9) {
    t11 = <>{t2}{t4}{t9}{t10}</>;
    $[22] = t10;
    $[23] = t4;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
export default DashboardLayout;